import React, { useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import Administration from './pages/Administration';
import OrderForm from './pages/OrderForm';
import ImportBookings from './pages/ImportBookings';
import Insights from './pages/Insights';
import Calendar from './pages/Calendar';
import AiChat from './components/AiChat';
import KeyboardShortcuts from './components/KeyboardShortcuts';

function PrivateRoute({ children, requireEdit }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Indlæser...</div>;
  }

  if (!user) return <Navigate to="/login" />;
  if (requireEdit && user.role === 'viewer') return <Navigate to="/" />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Indlæser...</div>;
  }

  return user ? <Navigate to="/" /> : children;
}

function PrivateExtras() {
  const { user } = useAuth();
  const [chatOpen, setChatOpen] = useState(false);

  const toggleChat = useCallback(() => {
    setChatOpen(prev => !prev);
  }, []);

  if (!user) return null;

  return (
    <>
      <AiChat externalOpen={chatOpen} onExternalToggle={toggleChat} />
      <KeyboardShortcuts onToggleChat={toggleChat} />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/orders" element={<PrivateRoute><Orders /></PrivateRoute>} />
            <Route path="/calendar" element={<PrivateRoute><Calendar /></PrivateRoute>} />
            <Route path="/insights" element={<PrivateRoute><Insights /></PrivateRoute>} />
            <Route path="/administration" element={<PrivateRoute><Administration /></PrivateRoute>} />
            <Route path="/book" element={<PrivateRoute requireEdit><OrderForm /></PrivateRoute>} />
            <Route path="/import" element={<PrivateRoute requireEdit><ImportBookings /></PrivateRoute>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          <PrivateExtras />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
